import React from 'react';
import { Tldraw } from 'tldraw';
import 'tldraw/tldraw.css';
import { Box, Typography } from '@mui/material';
import { DELETION_SAFE_SHAPE_UTILS } from '../shapes/boardShapeUtils';
import './pureTldrawCanvas.css';

/**
 * Stock tldraw with no Hashely pin cards, board sync, or custom shape utils.
 * Use /tldraw-test to verify built-in draw/eraser/arrow tools work in isolation.
 */
const PureTldrawCanvas = () => {
  return (
    <Box className="pure-tldraw-root">
      <Box className="pure-tldraw-banner">
        <Typography variant="caption" color="text.secondary">
          Pure tldraw test — no pin cards, no board sync, no custom listeners
        </Typography>
      </Box>
      <Box className="pure-tldraw-stage">
        <Tldraw shapeUtils={DELETION_SAFE_SHAPE_UTILS} />
      </Box>
    </Box>
  );
};

export default PureTldrawCanvas;
